"use strict";

export default class RouteReporterAPI {
  constructor($http, $window, config) {
    this.$http = $http;
    this.$window = $window;
    this.config = config;
  }

  post(url, data, options) {
    if (!this.config.apiUrl) throw Error("API URL Must be set during application startup");

    options = angular.extend({}, options, this.getOptions());

    return this.$http.post(`${this.config.apiUrl}${url}`, data, options);
  }

  get(url, options) {
    if (!this.config.apiUrl) throw Error("API URL Must be set during application startup");

    options = angular.extend({}, options, this.getOptions());

    return this.$http.get(`${this.config.apiUrl}${url}`, options);
  }

  getOptions() {
    let userString = this.$window.sessionStorage["userAuthInfo"];
    let user = JSON.parse(userString);

    let options = {
      headers: {
        "ALK-Language": undefined,
        "Authorization": `Bearer ${user.authToken}`
      }
    };

    return options;
  }


  isArray(arg) {
    return Object.prototype.toString.call(arg) === "[object Array]";
  }

}

RouteReporterAPI.$inject = ["$http", "$window", "alk.routereporter.config"];



// WEBPACK FOOTER //
// ./app/alk-fleetview/routereporter.api.js